import React, { Component } from 'react'
import Gallery from '../../../../shared/components/Gallery'
// import HelpText from '../../../../shared/components/HelpText'
import Evaluation from '../../../../shared/components/Evaluation'
import Header from '../../../../shared/components/Header'
import UserInfo from '../../../../shared/components/UserInfo'
// import axios from 'axios'
// import { isEqual } from 'lodash'
// import async from 'async'
// import Datetime from 'react-datetime'
// import moment from 'moment'
import { connect } from 'react-redux'
// import { Link } from 'react-router'

// Constants
import {
  // API_URL,
  // API_BASE,
  FILE_STORAGE
} from '../../../../constants'

// Styles
import './documentation.scss'

// Actions
import { triggerPopupActionBG, triggerPopup } from '../../../../actions/backdrop'
// import { openOverlay } from '../../../../actions/common'
import { updateCarOwner, sendInvitation, getCarOwnerStatus } from '../../../../actions/carownerportal'

import {
  getDocQuality,
  getDocProcess,
  getDocPhoto,
  getDocDeviations,
  getDocEvaluations,
  getDocOtherDamages
} from '../../../../actions/documentation'

// Utils
import { renderFullDate } from '../../../../utils/time'
import { hasAccess, hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../../../utils/auth'
import { formatCurrency } from '../../../../utils/currency'
import { translation, enumtranslate, getOrderNoteShareString } from '../../../../utils/helpers'
import { formatArrayToString } from '../../../../utils/array'

import Part from '../../../../shared/components/Extent/Part'
import Line from '../../../../shared/components/Extent/Line'
// Elements
import Col from '../../../../shared/elements/col'
import Panel from '../../../../shared/elements/panel'
import PanelHeader from '../../../../shared/elements/panelHeader'
import Grid from '../../../../shared/elements/grid'
import Inline from '../../../../shared/elements/inline'
import LabelWrapper from '../../../../shared/elements/labelWrapper'
import Divider from '../../../../shared/elements/divider'
// import Label from '../../../../shared/elements/label'
// import Text from '../../../../shared/elements/text'
// import HelpIcon from '../../../../shared/elements/helpIcon'
// import { ModalIcons } from '../../../../shared/elements/icons'

// import Modal from '../../../../shared/components/Modal'

class Documentation extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: true,
      quality: null,
      process: null,
      photo: null,
      // intDeviations: null,
      // extDeviations: null,
      evaluation: null,
      afterEvaluations: null,
      dimensions: {
        width: 0,
        height: 0
      }
      // carOwnerPortalStatus: {
      //   Logs: [],
      //   Mail: null,
      //   Phone: null,
      //   Status: null
      // }
    }
    this.getDocAll = this.getDocAll.bind(this)
    this.getDocQuality = this.getDocQuality.bind(this)
    this.getDocProcess = this.getDocProcess.bind(this)
    this.getDocPhoto = this.getDocPhoto.bind(this)
    this.getDeviations = this.getDeviations.bind(this)
    this.getDocEvaluations = this.getDocEvaluations.bind(this)
    this.getOtherDamages = this.getOtherDamages.bind(this)
    // this.getCarOwnerStatus = this.getCarOwnerStatus.bind(this)

    this.renderQuality = this.renderQuality.bind(this)
    this.renderProcess = this.renderProcess.bind(this)
    this.renderPhotoDoc = this.renderPhotoDoc.bind(this)
    this.renderInternalDeviation = this.renderInternalDeviations.bind(this)
    this.renderExternalDeviation = this.renderExternalDeviations.bind(this)
    this.renderDeviations = this.renderDeviations.bind(this)
    this.renderOtherDamage = this.renderOtherDamage.bind(this)
    this.renderEvaluation = this.renderEvaluation.bind(this)
    this.renderAfterEvaluation = this.renderAfterEvaluation.bind(this)
    this.renderAfterEvaluations = this.renderAfterEvaluations.bind(this)
    // this.renderCarOwnerPortalStatus = this.renderCarOwnerPortalStatus.bind(this)// add new
    // this.updateCarOwner = this.updateCarOwner.bind(this)
    // this.openOverlay = this.openOverlay.bind(this)
    // this.openCarOwnerResendPopup = this.openCarOwnerResendPopup.bind(this)
    // this.sendInvitation = this.sendInvitation.bind(this)

    this.updateDimensions = this.updateDimensions.bind(this)
    this.fnListener = window.debounce(this.updateDimensions, 250)
    this.onChange = this.onChange.bind(this)
    // this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    // Load data
    if (this.props.order.Id !== undefined) {
      this.getDocAll(this.props.order.Id)
    }
    window.addEventListener('resize', this.fnListener)
    this.updateDimensions()
    // if (this.props.headerButtonsCbProvider !== null) {
    //   this.props.headerButtonsCbProvider(() => { return [] })
    // }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.fnListener)
    // if (this.props.headerButtonsCbProvider !== null) {
    //   this.props.headerButtonsCbProvider(() => { return [] })
    // }
  }

  componentDidReceiveProps (props) {
    // Load data
  }

  componentWillReceiveProps (nextProps) {
    // Load data
    if (nextProps.order !== undefined && nextProps.order.Id !== undefined) {
      this.getDocAll(nextProps.order.Id)
    }
  }
  // openOverlay (e) {
  //   e.persist()
  //   this.setState({
  //     carrentalselectionmodal: false
  //   })
  //   this.props.triggerPopup(false)
  // }
  // openCarOwnerResendPopup (modal, isSMS, isEmail, date) {
  //   console.log('openCarOwnerResendPopup, modal', modal, 'isSMS', isSMS, 'isEmail', isEmail, 'date', date)
  //   this.setState({
  //     [modal]: true,
  //     carOwnerPortalResend: {
  //       isSMS: isSMS,
  //       isEmail: isEmail,
  //       date: renderFullDate(date)
  //     }
  //   })
  //   this.props.triggerPopup(true)
  // }
  // // get car owner status
  // getCarOwnerStatus (orderId) {
  //   return this.props.getCarOwnerStatus(orderId).then((res) => {
  //     // console.log(res.data)
  //     this.setState({
  //       carOwnerPortalStatus: res.data
  //     })
  //     return res
  //   })
  // }
  // sendInvitation () {
  //   const param = {
  //     orderId: this.props.order.Id,
  //     isSendSMS: this.state.carOwnerPortalResend.isSMS,
  //     IsSendEmail: this.state.carOwnerPortalResend.isEmail
  //   }

  //   this.props.sendInvitation(param).then((res) => {
  //     this.props.triggerPopup(false)
  //     this.setState({
  //       carrentalselectionmodal: false
  //     })
  //     this.getCarOwnerStatus(this.props.order.Id)

  //     // window.toastr.success(translation('18189'), translation('13424'))
  //   }, () => {
  //     // Err saving
  //     window.toastr.error(translation('18190'), translation('216'))
  //   })
  // }
  // updateCarOwner () {
  //   const params = {
  //     orderId: this.props.order.Id,
  //     mail: this.state.carOwnerPortalStatus.Mail,
  //     phone: this.state.carOwnerPortalStatus.Phone

  //   }
  //   this.props.updateCarOwner(params).then((res) => {
  //     // window.toastr.success(translation('18156'), translation('13424'))
  //   }, () => {
  //     // Err saving
  //     window.toastr.error(translation('18157'), translation('216'))
  //   })
  // }
  updateDimensions () {
    let w = window
    let d = document
    let documentElement = d.documentElement
    let body = d.getElementsByTagName('body')[0]

    let width = w.innerWidth || documentElement.clientWidth || body.clientWidth
    let height = w.innerHeight || documentElement.clientHeight || body.clientHeight

    this.setState({
      dimensions: {
        width: width,
        height: height
      }
    })
  }

  dimensionShow (dimensions) {
    let show = false
    dimensions.map((val, key) => {
      if (!show) {
        let higherThan = val[0]
        let lessThan = val[1]
        let width = this.state.dimensions.width
        if (width > higherThan && width < lessThan) show = true
      }
    })
    return show
  }

  getDocQuality (orderId) {
    if (!hasSubscriptionPermission(this.props.auth, 30) && (hasSubscriptionPermission(this.props.auth, 0) && !hasPartnerSubscriptionPermission(this.props.auth, 30))) return null
    return this.props.getDocQuality(orderId).then((res) => {
      this.setState({
        quality: res.data
      })
      return res
    })
  }

  getDocProcess (orderId) {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    return this.props.getDocProcess(orderId).then((res) => {
      this.setState({
        process: res.data
      })
      return res
    })
  }

  getDocPhoto (orderId) {
    return this.props.getDocPhoto(orderId).then((res) => {
      this.setState({
        photo: res.data
      })
      return res
    })
  }

  getDeviations (orderId) {
    if (!hasSubscriptionPermission(this.props.auth, 30) && (hasSubscriptionPermission(this.props.auth, 0) && !hasPartnerSubscriptionPermission(this.props.auth, 30))) return null
    return this.props.getDocDeviations(orderId).then((res) => {
      let intDeviations = res.data.InternalDeviations
      let extDeviations = res.data.ExternalDeviations
      this.setState({
        intDeviations: intDeviations,
        extDeviations: extDeviations
      }, () => {
        this.setState({
          internalDeviationsTotalCost: res.data.InternalDeviationsTotalCost,
          externalDeviationsTotalCost: res.data.ExternalDeviationsTotalCost
        })
      })
      return res
    })
  }

  getOtherDamages (orderId) {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    return this.props.getDocOtherDamages(orderId).then((res) => {
      this.setState({
        otherDamages: res.data.OtherDamages
      })
      return res
    })
  }

  getDocEvaluations (orderId) {
    if (!hasSubscriptionPermission(this.props.auth, 30) && (hasSubscriptionPermission(this.props.auth, 0) && !hasPartnerSubscriptionPermission(this.props.auth, 30))) return null
    return this.props.getDocEvaluations(orderId).then((res) => {
      this.setState({
        evaluation: res.data.Estimation,
        afterEvaluations: res.data.AfterEvaluations
      })
      return res
    })
  }

  getDocAll (orderId) {
    // Trigger popup action BG - START
    this.props.triggerPopupActionBG(true)
    // Trigger popup action BG - END

    // Load doc. data
    let promise1 = this.getDocQuality(orderId)
    let promise2 = this.getDocProcess(orderId)
    let promise3 = this.getDocPhoto(orderId)
    let promise4 = this.getDeviations(orderId)
    let promise5 = this.getDocEvaluations(orderId)
    let promise6 = this.getOtherDamages(orderId)
    // let promise7 = this.getCarOwnerStatus(orderId)

    // Wait for all to resolve
    Promise.all([promise1, promise2, promise3, promise4, promise5, promise6]).then(values => {
      this.setState({
        isLoading: false
      })
      // Trigger popup action BG - START
      this.props.triggerPopupActionBG(false)
      // Trigger popup action BG - END
    }, () => {
      this.setState({
        isLoading: false
      })
      // Trigger popup action BG - START
      this.props.triggerPopupActionBG(false)
      // Trigger popup action BG - END
    })
  }
  onChange (e) {
    e.persist()
    let value = e.target.value

    this.setState({
      carOwnerPortalStatus: {
        ...this.state.carOwnerPortalStatus,
        [e.target.name]: value
      }
    })
  }

  // onBlur (e) {
  //   this.updateCarOwner()
  // }
  render () {
    if (this.props.order.Id === 'undefined' || this.state.isLoading) {
      const loadingSpinner = () => {
        return (
          <Panel>
            <div className='animated-background'>
              <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
              <span className='sr-only'>{translation('13382')}...</span>
            </div>
          </Panel>
        )
      }
      return (
        <div className='documentation__screen'>
          {!this.props.disabled && (
            <Header
              router={this.props.router}
              showBack
              headerButtonsGoBack={this.props.renderButtonsGoBack}
              renderButtons={() => { return [] }}
            >
              {this.props.renderTabs()}
            </Header>
          )}
          <div>
            {this.props.auth.user.DepartmentType !== 1 && (
              <Col>
                {loadingSpinner()}
                {loadingSpinner()}
              </Col>
            )}
            <Col>
              {loadingSpinner()}
            </Col>
            {this.props.auth.user.DepartmentType !== 1 && (
              <Col>
                {loadingSpinner()}
                {loadingSpinner()}
              </Col>
            )}
            <Col>
              {loadingSpinner()}
              {loadingSpinner()}
            </Col>
          </div>
        </div>
      )
    }

    let showQuality = this.props.auth.user.DepartmentType !== 1 // || (hasSubscriptionPermission(this.props.auth, 0) && hasPartnerSubscriptionPermission(this.props.auth, 30))
    return (
      <div className='documentation__screen'>
        {!this.props.disabled && (
          <Header
            router={this.props.router}
            showBack
            headerButtonsGoBack={this.props.renderButtonsGoBack}
            renderButtons={() => { return [] }}
          >
            {this.props.renderTabs()}
          </Header>
        )}
        <div className='row clearfix'>
          <Col>
            {this.renderWreckedOrder()}
            {showQuality && this.renderQuality()}
            {this.renderCustomChecks()}
            {this.renderPhotoDoc()}
            {this.dimensionShow([[0, 1401]]) && (
              <div>
                {this.props.auth.user.DepartmentType !== 1 && this.renderInternalDeviations()}
                {this.renderExternalDeviations()}
                {this.renderOtherDamage()}
              </div>
            )}
          </Col>
          <Col>
            {this.renderProcess()}
          </Col>
          {this.dimensionShow([[1400, 10000]]) && (
            <Col>
              {this.props.auth.user.DepartmentType !== 1 && this.renderInternalDeviations()}
              {this.renderExternalDeviations()}
              {this.renderOtherDamage()}
            </Col>
          )}
          <Col>
            {this.renderEvaluation()}
            {this.renderAfterEvaluations()}
          </Col>
          {/* this.state.carOwnerPortalStatus.Status !== null && (
            <Col>
              {this.renderCarOwnerPortalStatus()}
            </Col>
          ) */}

        </div>
      </div>
    )
  }

  renderQuality () {
    let quality = this.state.quality
    if (quality === null) return null
    const renderOrderChecks = (quality) => {
      let qualityChecks = quality.OrderChecks.filter(x => x.QualityCheckTaskName === '')
      if (qualityChecks.length === 0) return null
      const renderEntry = (val, key) => {
        if (val === null || val === undefined) return null
        let step = translation(enumtranslate('PaintShopOrderSteps', val.Step))
        let isStart = val.StartOrEnd === 1
        let user = val.PerformedByUserInfo
        let date = val.PerformedAt
        return (
          <li key={key}>
            <Grid cols={[5, 6, 1]} spacing={[1]}>
              <span>{renderFullDate(date)}</span>
              <span>{step} - {isStart ? translation('1223') : translation('2062')}, <UserInfo user={user} /></span>
            </Grid>
          </li>
        )
      }

      return (
        <div>
          <PanelHeader text={translation('1929')} />
          <ul>
            {qualityChecks.map(renderEntry)}
          </ul>
        </div>
      )
    }

    const renderLayerThickness = (quality) => {
      if (quality.PaintThicknessChecks.length === 0) return null
      const renderEntry = (val, key) => {
        if (val === null || val === undefined) return null
        let step = translation(enumtranslate('PaintShopOrderSteps', val.Step))
        let isStart = val.StartOrEnd === 1
        let user = val.PerformedByUserInfo
        let date = val.PerformedAt
        let value = val.ThicknessValue
        return (
          <li key={key}>
            <Grid cols={[5, 6, 1]} spacing={[1]}>
              <span>{renderFullDate(date)}</span>
              <span>{step} - {isStart ? translation('1223') : translation('2062')}, <UserInfo user={user} /></span>
              <span>{value}</span>
            </Grid>
          </li>
        )
      }
      return (
        <div>
          <PanelHeader text={translation('370')} />
          <ul>
            {quality.PaintThicknessChecks.map(renderEntry)}
          </ul>
        </div>
      )
    }

    const renderWarrantyCode = (quality) => {
      let code = quality.WarrantyCode
      if (code.trim() === '') return null
      return (
        <div>
          <PanelHeader text={translation('13396')} />
          <div>{code}</div>
        </div>
      )
    }

    const renderNoChecks = (quality) => {
      if (quality.OrderChecks.length !== 0 || quality.PaintThicknessChecks.length !== 0 || quality.WarrantyCode.trim() !== '') return null
      return (
        <div>
          {translation('1919')}
        </div>
      )
    }

    return (
      <Panel title={translation('1929')}>
        {renderNoChecks(quality)}
        {renderOrderChecks(quality)}
        {renderLayerThickness(quality)}
        {renderWarrantyCode(quality)}
      </Panel>
    )
  }

  renderCustomChecks () {
    let quality = this.state.quality
    if (quality === null) return null
    let customChecks = quality.OrderChecks.filter(x => x.QualityCheckTaskName !== '')
    if (customChecks.length === 0) return null

    // Group checks
    const groupedChecks = customChecks.reduce((result, check) => {
      if (result[check.QualityCheckTaskName]) {
        result[check.QualityCheckTaskName].push(check)
      } else {
        result[check.QualityCheckTaskName] = [check]
      }

      return result
    }, {}) // { [name]: [ ...checks ], ... }

    const renderGroup = (groupKey, key) => {
      return (
        <div>
          <PanelHeader text={groupKey} />
          <ul>
            {groupedChecks[groupKey].map(renderEntry)}
          </ul>
        </div>
      )
    }

    const renderEntry = (val, key) => {
      if (val === null || val === undefined) return null
      let step = translation(enumtranslate('PaintShopOrderSteps', val.Step))
      let isStart = val.StartOrEnd === 1
      let user = val.PerformedByUserInfo
      let date = val.PerformedAt
      return (
        <li key={key}>
          <Grid cols={[5, 6, 1]} spacing={[1]}>
            <span>{renderFullDate(date)}</span>
            <span>
              <div>{translation(val.Status)}</div>
              {step} - {isStart ? translation('1223') : translation('2062')}, <UserInfo user={user} />
              <div>{val.Comment}</div>
            </span>
          </Grid>
        </li>
      )
    }

    return (
      <Panel title={translation('17893')}>
        <ul>
          {Object.keys(groupedChecks).map(renderGroup)}
        </ul>
      </Panel>
    )
  }

  renderProcess () {
    // Access
    if (hasAccess([4], this.props.auth.user.UserType)) return null
    // Process
    let process = this.state.process
    if (process === null) return null
    const renderStep = (val, key) => {
      if (val === undefined || val === null) return null
      if (val.StepRecords.length === 0) return null
      const renderStepRecord = (val, key) => {
        if (val === undefined || val === null) return null
        let user = val.UserInfo
        let stopTime = val.StopTime
        let startTime = val.StartTime
        let usedTime = val.UsedTime
        let weight = val.SharedTime

        return (
          <Grid cols={[7, 0.5]} key={key} spacing={[1]}>
            <span>
              <div>
                <span>{renderFullDate(startTime, false)} </span>
                <span> {renderFullDate(startTime, true, true)} - {renderFullDate(stopTime, true, true)} ({weight})</span>
              </div>
              <div><UserInfo user={user} /></div>
            </span>
            <span>{usedTime}</span>
          </Grid>
        )
      }
      return (
        <div key={'step_' + key}>
          <LabelWrapper labelText={(
            <Inline fillChildNum={[0]} block>
              {translation(enumtranslate('PaintShopOrderSteps', val.StepId))}
              <span>{val.TotalUsedTime}</span>
            </Inline>
          )}>
            <div className='stepUserData'>{val.StepRecords.map(renderStepRecord)}</div>
          </LabelWrapper>
        </div>
      )
    }

    let usedTime = process.UsedTime
    let usedTimeWithTransport = process.UsedTimeWithTransport
    let assignedTimeForsi = process.AssignedTimeForsi
    let assignedTime = process.AssignedTime
    let estimatedTime = process.EstimatedTime
    let gainHour = process.GainHour
    let gainHourWithoutTransport = process.GainHourWithoutTransport
    let gainIndex = process.GainIndex
    let gainIndexWithoutTransport = process.GainIndexWithoutTransport
    const renderReferredOut = () => {
      if (!this.props.order.IsReferredOut || this.props.order.OrderConnection === undefined) return null
      let referredName = this.props.order.OrderConnection.TransferedToCompanyName
      if (this.props.order.OrderConnection.TransferedToCompanyName === undefined || this.props.order.OrderConnection.TransferedToCompanyName === null) {
        referredName = ''
      }
      let referText = translation('13558') + ' ' + referredName
      return (
        <div>{referText}
        </div>
      )
    }
    return (
      <Panel title={translation('359')}>
        {renderReferredOut()}
        <ul>
          {usedTimeWithTransport !== '00:00' && (
            <li className='clearfix'>
              <Inline fillChildNum={[0]} block>
                <div>{translation('2066')}</div>
                <div>{usedTimeWithTransport}</div>
              </Inline>
            </li>
          )}
          {usedTime !== '00:00' && (
            <li className='clearfix'>
              <Inline fillChildNum={[0]} block>
                <div>{translation('2067')}</div>
                <div>{usedTime}</div>
              </Inline>
            </li>
          )}
          {assignedTimeForsi !== '00:00' && (
            <li className='clearfix'>
              <Inline fillChildNum={[0]} block>
                <div>{translation('2063')}</div>
                <div>{assignedTimeForsi}</div>
              </Inline>
            </li>
          )}
          {estimatedTime !== '00:00' && (
            <li className='clearfix'>
              <Inline fillChildNum={[0]} block>
                <div>{translation('16836')}</div>
                <div>{estimatedTime}</div>
              </Inline>
            </li>
          )}
          {assignedTime !== '00:00' && (
            <li className='clearfix'>
              <Inline fillChildNum={[0]} block>
                <div>{translation('2064')}</div>
                <div>{assignedTime}</div>
              </Inline>
            </li>
          )}
        </ul>
        <div className='assignSteps'>
          {process.AssignedStepTimes.map(renderStep)}
        </div>
        <ul>
          {gainHour !== null && (
            <li className='clearfix'>
              <Inline fillChildNum={[0]} block>
                <div>{translation('2068')}</div>
                <div>{gainHour}</div>
              </Inline>
            </li>
          )}
          {gainHourWithoutTransport !== null && (
            <li className='clearfix'>
              <Inline fillChildNum={[0]} block>
                <div>{translation('2069')}</div>
                <div>{gainHourWithoutTransport}</div>
              </Inline>
            </li>
          )}
          {gainIndex !== null && (
            <li className='clearfix'>
              <Inline fillChildNum={[0]} block>
                <div>{translation('2070')}</div>
                <div>{gainIndex}</div>
              </Inline>
            </li>
          )}
          {gainIndexWithoutTransport !== null && (
            <li className='clearfix'>
              <Inline fillChildNum={[0]} block>
                <div>{translation('2071')}</div>
                <div>{gainIndexWithoutTransport}</div>
              </Inline>
            </li>
          )}
        </ul>
      </Panel>
    )
  }

  // // Add new component 1515 status, 1021 des 31 m 18183 E-m 18219 re-s
  // renderCarOwnerPortalStatus () {
  //   const cols = [3, 2, 4]
  //   let carOwnerPortalStatus = this.state.carOwnerPortalStatus
  //   // console.log('carOwnerPortalStatus:', carOwnerPortalStatus)
  //   const closeCarRentalSelectionModal = () => {
  //     this.props.triggerPopup(false)
  //     this.setState({
  //       carrentalselectionmodal: false
  //     })
  //   }

  //   const renderStatusElement = (status) => {
  //     let text = ''
  //     let helpText = ''
  //     switch (status) {
  //       case 1:
  //         text = translation('295')
  //         helpText = translation(`18221`)
  //         break
  //       case 2:
  //         text = translation('18225')
  //         helpText = translation(`18222`)
  //         break
  //       case 3:
  //         text = translation('18226')
  //         helpText = translation(`18223`)
  //         break
  //       case 4:
  //         text = translation('18227')
  //         helpText = translation(`18224`)
  //         break
  //     }
  //     return (
  //       <div>
  //         <span>{text}</span>
  //         <HelpIcon helpText={helpText} size='t' />
  //       </div>
  //     )
  //   }
  //   const renderLogElement = (val, key) => {
  //     return (
  //       <li key={key}>
  //         <Grid cols={cols} spacing={2}>
  //           <div className='date'>{renderFullDate(val.Date)}</div>
  //           <div className='user'>{val.Name}</div>
  //           <div className='eventtype'>{translation(val.Description)}</div>
  //         </Grid>
  //       </li>
  //     )
  //   }

  //   // console.log('state (car owner)', this.state)
  //   let noticeText = ''
  //   let dateOfStatusText = ''
  //   let date = ''
  //   /*
  //       Active = 1,
  //       NotInvited = 2,
  //       Invited = 3,
  //       RejectedByCarOwner = 4
  //   */
  //   switch (carOwnerPortalStatus.Status) {
  //     case 1:
  //       noticeText = translation(18221)         // The car owner portal is active and can be used by car owner
  //       dateOfStatusText = translation(18254)   // Accepted by the car owner
  //       date = this.state.carOwnerPortalStatus.Logs.filter(x => x.Status === 1).slice(0, 1)[0].Date   // Latest date of car owner accept (active)
  //       break
  //     case 2:
  //       noticeText = translation(18222)         // no invitation has been sent to the car owner
  //       dateOfStatusText = null
  //       break
  //     case 3:
  //       noticeText = translation(18223)         // An invitation has been sent by SMS or e-mail to the car owner, pending for approval of terms and conditions
  //       dateOfStatusText = translation(18255)   // The car owner was invited
  //       date = carOwnerPortalStatus.Logs.filter(x => x.Status === 3).slice(0, 1)[0].Date   // Latest date of invite
  //       break
  //     case 4:
  //       noticeText = translation(18233)         // The invitation has previously been rejected by the car owner. Please ensure a verbal consent before re-sending the invitation.
  //       dateOfStatusText = translation(18227)   // Rejected by car owner
  //       date = carOwnerPortalStatus.Logs.filter(x => x.Status === 4).slice(0, 1)[0].Date   // Latest date of car owner decline
  //       break
  //   }
  //   // console.log('carOwnerPortalStatus.Logs', carOwnerPortalStatus.Logs)

  //   let carOwnerPortalLatestLogDate = null
  //   if (carOwnerPortalStatus.Logs && carOwnerPortalStatus.Logs.length > 0) carOwnerPortalLatestLogDate = carOwnerPortalStatus.Logs[0].Date

  //   return (
  //     <Panel title={18217}>
  //       {this.state.carrentalselectionmodal && <div className='carrentalselection_modal'>
  //         <Modal
  //           show={this.state.carrentalselectionmodal}
  //           onClose={closeCarRentalSelectionModal}
  //           header={translation(18219)}
  //           icon={ModalIcons.Note}
  //           bottomBarProps={{
  //             actionLabelText: translation(18234),
  //             onActionClick: this.sendInvitation
  //           }}>
  //           <div>
  //             <div className='text-bold'>{noticeText}</div>
  //             {dateOfStatusText} {renderFullDate(date)}
  //           </div>
  //         </Modal>
  //       </div>}
  //       <div className='car-owner'>
  //         <LabelWrapper labelText={translation(18218)}>
  //           <div>{renderStatusElement(carOwnerPortalStatus.Status)}</div>
  //         </LabelWrapper>
  //       </div>
  //       <div className='car-owner'>
  //         <Text
  //           // className='size-large form-control'
  //           labelText={31}
  //           name='Phone'
  //           value={carOwnerPortalStatus.Phone}
  //           placeholder={translation(31)}
  //           onChange={this.onChange}
  //           onBlur={this.onBlur}
  //         />
  //         <a className={carOwnerPortalStatus.Phone ? 'element-re-send' : 'disabled-send'} href='#' onClick={() => this.openCarOwnerResendPopup('carrentalselectionmodal', true, false, carOwnerPortalLatestLogDate)} >{translation(18219)}</a>
  //       </div>
  //       <div className='car-owner'>
  //         <Text
  //           labelText={18183}
  //           // className='size-large form-control'
  //           name='Mail'
  //           value={carOwnerPortalStatus.Mail}
  //           placeholder={translation(18183)}
  //           onChange={this.onChange}
  //           onBlur={this.onBlur}
  //         />
  //         <a className={carOwnerPortalStatus.Mail ? 'element-re-send' : 'disabled-send'} href='#' onClick={() => this.openCarOwnerResendPopup('carrentalselectionmodal', false, true, carOwnerPortalLatestLogDate)} >{translation(18219)}</a>
  //       </div>
  //       <Divider />
  //       <div className='car-owner'>
  //         <PanelHeader text={translation(2211)} />
  //         <ul>
  //           <li>
  //             <Grid cols={cols}>
  //               <LabelWrapper labelText={translation(388)} />
  //               <LabelWrapper labelText={translation(30)} />
  //               <LabelWrapper labelText={translation(1021)} />
  //             </Grid>
  //           </li>
  //           {carOwnerPortalStatus.Logs.map(renderLogElement)}
  //         </ul>
  //       </div>
  //     </Panel>
  //   )
  // }

  renderWreckedOrder () {
    if (!hasSubscriptionPermission(this.props.auth, 30)) return null
    const { IsWrecked, WreckedDate, WreckedByName, WreckedFromStep, Notes } = this.props.order
    if (!IsWrecked) return null

    const step = translation(enumtranslate('PaintShopOrderSteps', WreckedFromStep))
    // If the wrecking has previously failed, use the newest wreck comment
    const comment = [...Notes].reverse().find(n => n.SourceID === 20)

    return (
      <Panel title={translation('15244')}>
        <div>
          {renderFullDate(WreckedDate)}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{step} - {WreckedByName}
          {comment !== undefined && <div className='qualityGroup'>{comment.Note}</div>}
        </div>
      </Panel>
    )
  }

  renderPhotoDoc () {
    let photo = this.state.photo
    if (photo === undefined || photo === null || photo.PhotoDocumentations === null) return null

    const renderEntry = (val, key) => {
      if (val[0] === undefined || val[0] === null) return null
      if (val[0].Images.length === 0) return null
      const renderEntry2 = (val, key) => {
        const renderImage = (v, key) => {
          if (v === undefined || v === null) return null
          return (
            <a key={'img_' + key} href={FILE_STORAGE + v.FileURL} data-lightbox='gallery_photodoc' data-title={v.FileName}>
              <img style={/* Remove this */{ width: '100%' }} src={FILE_STORAGE + v.ThumbURL} />
            </a>
          )
        }

        return (
          <div key={key}>
            <PanelHeader text={translation(enumtranslate('PaintShopOrderSteps', val.Step))} />

            <Grid>
              <div>{val.Images.map(renderImage)}</div>
              <div>
                {formatArrayToString(val.Comment.Note)}
                <Divider noLine />

                <LabelWrapper labelText={translation('263')}>
                  <UserInfo user={val.Comment.UserInfo} />
                </LabelWrapper>
                <LabelWrapper labelText={translation('176')}>
                  {renderFullDate(val.Comment.NoteDate)}
                </LabelWrapper>
                {val.Comment.ShareType > 0 && (<LabelWrapper labelText={translation('17861')}>
                  {getOrderNoteShareString(val.Comment.ShareType)}
                </LabelWrapper>)}
              </div>
            </Grid>
          </div>
        )
      }

      return (
        <div key={key}>
          {val.map(renderEntry2)}
        </div>
      )
    }

    const renderEmptyPhotodocs = () => {
      let itemFound = false
      photo.PhotoDocumentations.map((val) => {
        if (val[0] !== undefined) {
          itemFound = true
        }
      })
      if (itemFound) return null
      return (
        <div>
          {translation('1920')}
        </div>
      )
    }

    return (
      <Panel title={translation('2065')}>
        <div>
          {renderEmptyPhotodocs()}
          {photo.PhotoDocumentations.map(renderEntry)}
        </div>
      </Panel>
    )
  }

  renderInternalDeviations () {
    if (!hasSubscriptionPermission(this.props.auth, 30)) return null
    // Access
    if (hasAccess([4], this.props.auth.user.UserType)) return null
    // Internal deviation
    let deviations = this.state.intDeviations
    if (deviations === undefined || deviations === null || deviations.length === 0) {
      return (
        <Panel title={translation('382')}>
          {translation('2094')}
        </Panel>
      )
    }
    return (
      <Panel title={translation('382')}>
        {this.renderDeviations(deviations, 1)}
      </Panel>
    )
  }

  renderExternalDeviations () {
    if (!hasSubscriptionPermission(this.props.auth, 30) && (hasSubscriptionPermission(this.props.auth, 0) && !hasPartnerSubscriptionPermission(this.props.auth, 30))) return null
    // Access
    if (this.props.auth.user.DepartmentType === 1 && hasAccess([4], this.props.auth.user.UserType)) return null

    let deviations = this.state.extDeviations
    let title = this.props.auth.user.DepartmentType !== 1 ? '383' : '32'
    if (hasAccess([4], this.props.auth.user.UserType)) title = '32'

    if (deviations === undefined || deviations === null || deviations.length === 0) {
      return (
        <Panel title={translation(title)}>
          {this.props.auth.user.DepartmentType === 1 || hasAccess([4], this.props.auth.user.UserType) ? translation('16660') : translation('2095')}
        </Panel>
      )
    }
    return (
      <Panel title={translation(title)}>
        {this.renderDeviations(deviations, 2)}
      </Panel>
    )
  }

  renderDeviations (deviationArray, deviationType) {
    if (deviationArray === undefined || deviationArray == null || deviationArray.length === 0) return null
    const renderDeviation = (deviation, key) => {
      if (deviation === undefined || deviation === null) return null
      let parts = deviation.Parts
      let files = deviation.DeviationFiles
      const renderPartsEntry = (val, key) => {
        // let partName = val.Part.Name
        // let partDict = val.Part.DictionaryKey
        // // let partDictKey = val.Part.DictionaryKey
        // let reasons = val.DeviationReasons
        // let customReasons = val.CustomDeviationReasons
        // // console.log('renderDeviations', val)
        // const renderReasonEntry = (v, key) => {
        //   // console.log('render reason entry')
        //   // let reasonId = val.DeviationReasonId
        //   // let deviationId = val.DeviationReasonId
        //   let text = ''
        //   if (!v.CustomDeviationReasonId) {
        //     let classId = v.DeviationType.ClassId
        //     let type = v.DeviationType.Type
        //     switch (classId) {
        //       case 1:
        //         text = translation(enumtranslate('InternalDeviationTypes', type))
        //         break
        //       case 2:
        //         text = translation(enumtranslate('ExternalDeviationTypes', type))
        //         break
        //     }
        //   }
        //   if (text === '') text = v.CustomReason
        //   return (
        //     <div key={'reason_' + key}>
        //       <div>- {text}</div>
        //     </div>
        //   )
        // }

        return (
          <li key={'part_' + key} className='extent-content'>
            <Part part={val} />
            {/* <h3 className='h3'>{translation(partDict)}</h3>
            <div>
              {reasons !== null && reasons.map(renderReasonEntry)}
              {customReasons !== null && customReasons.map(renderReasonEntry)}
            </div> */}
          </li>
        )
      }

      const renderFileEntry = (v, key) => {
        let file = v.OrderFile
        return (
          <a href={FILE_STORAGE + file.FileURL} data-lightbox={'gallery_deviations_' + deviationType} data-title={file.FileName} key={key}>
            <img style={/* Remove this */{ width: '100%' }} src={FILE_STORAGE + file.ThumbURL} />
          </a>
        )
      }

      // renderDeviation return
      const hideCostFromBodyCustomer = this.props.auth.departmentType === 1 && !deviation.ShowCostCustomer

      return (
        <div key={key}>
          <PanelHeader text={translation(enumtranslate('PaintShopOrderSteps', deviation.StepId))} />

          <Grid>
            <div>{files !== undefined && files.map(renderFileEntry)}</div>
            <div>
              <ul>
                {parts !== undefined && parts.map(renderPartsEntry)}
              </ul>

              <Divider />
              {(hasAccess([3, 5, 7], this.props.auth.user.UserType) && !hideCostFromBodyCustomer || (hasAccess([4], this.props.auth.user.UserType) && deviation.ShowCostCustomer)) && (
                <LabelWrapper labelText={translation('337')}>
                  {formatCurrency(deviation.Cost)}
                </LabelWrapper>
              )}

              {hasAccess([3, 5, 7], this.props.auth.user.UserType) && deviation.ShowCostCustomer && <div>{translation('14940')}</div>}
              {hasAccess([3, 5, 7], this.props.auth.user.UserType) && deviation.TransferCostToInvoice && <div>{translation('14941')}</div>}

              <Divider noLine />
              {deviation.DeviationComment.Note !== null && formatArrayToString(deviation.DeviationComment.Note)}
              <Divider />

              <LabelWrapper labelText={translation('263')}>
                <UserInfo user={deviation.DeviationComment.UserInfo} />
              </LabelWrapper>
              <LabelWrapper labelText={translation('176')}>
                {renderFullDate(deviation.DeviationComment.NoteDate)}
              </LabelWrapper>
              {deviation.DeviationComment.ShareType > 0 && (<LabelWrapper labelText={translation('17861')}>
                {getOrderNoteShareString(deviation.DeviationComment.ShareType)}
              </LabelWrapper>)}
            </div>
          </Grid>
        </div>
      )
    }

    // renderDeviatons return
    return (
      <div>
        {deviationArray.map(renderDeviation)}
      </div>
    )
  }

  renderOtherDamage () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    if (this.props.auth.departmentType !== 1) return null

    const otherDamages = this.state.otherDamages

    const renderDamage = (dmg, key) => {
      const renderFile = (file, k) => {
        return (
          <a href={FILE_STORAGE + file.FileURL} data-lightbox={'gallery_otherDamage'} data-title={file.FileName} key={k}>
            <img src={FILE_STORAGE + file.ThumbURL} />
          </a>
        )
      }
      const renderPart = (part, k) => {
        const renderDmgItem = (item, j) => {
          let name = ''
          if (item.Type === 10) {
            name = item.CustomName
          } else {
            name = translation(enumtranslate('OtherDamageTypes', item.Type))
          }

          return (
            <div key={'damage_' + j}>
              <div>- {name}</div>
            </div>
          )
        }

        return (
          <div key={'part_' + k}>
            <h3 className='h3'>{translation(part.Part.DictionaryKey)}</h3>
            <div>
              {part.OtherDamages && part.OtherDamages.map(renderDmgItem)}
            </div>
          </div>
        )
      }

      return (
        <li key={key}>
          <div className='stepName'>{translation(enumtranslate('PaintShopOrderSteps', dmg.StepId))}</div>
          <div className='stepImageGallery clearfix divImages'>
            <div className='left'>
              {dmg.Files.map(renderFile)} <br />
            </div>
            <div>
              <ul>
                {dmg.Parts.map(renderPart)} <br />
              </ul>
              <div>
                {dmg.Comment && formatArrayToString(dmg.Comment.Note)}
              </div>
              <br />
              <div>
                <LabelWrapper labelText={translation('263') + ':'}>
                  <UserInfo user={dmg.UserInfo} />
                </LabelWrapper>
                <div>
                  {translation('176')}<b>: </b>
                  {renderFullDate(dmg.Date)}
                </div>
              </div>
            </div>
          </div>
        </li>
      )
    }

    return (
      <Panel title={translation('15187')}>
        {(otherDamages === null || otherDamages.length === 0) ? translation('16470') : (
          <ul>
            {otherDamages.map(renderDamage)}
          </ul>)}
      </Panel>
    )
  }

  renderEvaluation () {
    if (!hasSubscriptionPermission(this.props.auth, 30) && (hasSubscriptionPermission(this.props.auth, 0) && !hasPartnerSubscriptionPermission(this.props.auth, 30))) return null

    return (
      <Panel title={translation('13363')}>
        {this.state.evaluation !== null ? <Evaluation orderId={this.props.order.Id} evaluation={this.state.evaluation} /> : translation('13534')}
      </Panel>
    )
  }

  renderAfterEvaluations () {
    let afterEvals = this.state.afterEvaluations
    if (afterEvals === null) return null

    return (
      <div>
        {afterEvals.map(this.renderAfterEvaluation)}
      </div>
    )
  }

  renderAfterEvaluation (afterEval, afterKey) {
    // renderImage
    const renderImage = (item, key) => {
      let url = FILE_STORAGE + item.ThumbURL
      let fullUrl = FILE_STORAGE + item.FileURL
      return (
        <div key={key}>
          <a href={fullUrl} data-lightbox='gallery_aftereval' data-title={item.FileName}><img src={url} /></a>
        </div>
      )
    }
    // renderRefinishType
    const renderRefinishType = (type, key) => {
      if (type.ReportTask !== null && type.ApromasTasks.length === 0) {
        return (
          <li className='clearfix' key={'refinish_' + key}>
            <div>
              {type.ReportTask !== null && <strong>{type.ReportTask.ReportItemLineNumber}</strong>}
              {type.ReportTask !== null && type.ReportTask.ReportItemLineText}
            </div>
          </li>
        )
      }
      const renderTask = (item, k) => {
        return (
          <div key={'refinish_' + key + '_task_' + k}>
            {item.Type}
          </div>
        )
      }
      return (
        <li className='clearfix' key={'refinish_' + key}>
          {type.ReportTask !== null && (<div>
            <div className='strike_through' />
            {type.ReportTask !== null && <strong>{type.ReportTask.ReportItemLineNumber}</strong>}
            {type.ReportTask !== null && type.ReportTask.ReportItemLineText}
          </div>)}
          <div>
            {type.ApromasTasks.map(renderTask)}
          </div>
        </li>
      )
    }
    // renderStartTime
    const renderStartTime = (time, key) => {
      /* // let type = 1
      let startTime = time.ReportTask !== null ? time.ReportTask.StartTimePlastic : null
      let text = translation('413')
      if (time.ReportTask !== null && time.ReportTask.StartTimePlastic !== null) {
        // type = 1
        startTime = time.ReportTask.StartTimePlastic
        text = translation('413')
      } else if (time.ReportTask !== null && time.ReportTask.StartTimeMetal !== null) {
        // type = 2
        startTime = time.ReportTask.StartTimeMetal
        text = translation('414')
      } else if (time.ReportTask !== null && time.ReportTask.StartTimeSpot !== null) {
        // type = 3
        startTime = time.ReportTask.StartTimeSpot
        text = translation('13250')
      } else if (time.ReportTask !== null && time.ReportTask.StartTimeTwoColor !== null) {
        // type = 4
        startTime = time.ReportTask.StartTimeTwoColor
        text = translation('13251')
      } */
      if (time.ReportTask !== null && time.ApromasTasks.length === 0) {
        return (
          <li className='clearfix' key={'refinish_' + key}>
            <div>
              <strong>{time.ReportTask.ReportItemLineText}</strong>
              <span>{time.ReportTask.ReportItemWorkUnits} {translation('885')}</span>
            </div>
          </li>
        )
      }
      const renderTask = (item, k) => {
        return (
          <div key={'refinish_task_' + k}>
            {item.Type} ({item.Ae} {translation('885')})
          </div>
        )
      }
      return (
        <li className='clearfix' key={'refinish_' + key}>
          {time.ReportTask !== null && (<div>
            <div className='strike_through' />
            <strong>{time.ReportTask.ReportItemLineText}</strong>
            <span>{time.ReportTask.ReportItemWorkUnits} {translation('885')}</span>
          </div>)}
          <div>
            {time.ApromasTasks.map(renderTask)}
          </div>
        </li>
      )
    }
    // renderHourPrice
    const renderHourPrice = (hour, key) => {
      if (hour.ReportTask !== null && hour.ApromasTasks.length === 0) {
        return (
          <li className='clearfix' key={'hourly_' + key}>
            <div>
              <strong>{translation('419')}</strong>
              <span>{hour.ReportTask.HourPrice} {this.props.currencyCode}</span>
            </div>
          </li>
        )
      }
      const renderTask = (item, k) => {
        return (
          <div key={'hourly_task_' + k}>
            {item.Price}
          </div>
        )
      }
      return (
        <li className='clearfix' key={'hourly_' + key}>
          {hour.ReportTask !== null && (<div>
            <div className='strike_through' />
            <strong>{translation('419')}</strong>
            <span>{hour.ReportTask.HourPrice} {this.props.currencyCode}</span>
          </div>)}
          <div>
            {hour.ApromasTasks.map(renderTask)}
          </div>
        </li>
      )
    }
    // renderMaterialShare
    const renderMaterialShare = (share, key) => {
      if (share.ReportTask !== null && share.ApromasTasks.length === 0) {
        return (
          <li className='clearfix' key={'share_' + key}>
            <div>
              <strong>{translation('415')}</strong>
              <span>{share.ReportTask.ReportItemGenericValue}</span>
            </div>
          </li>
        )
      }
      const renderTask = (item, k) => {
        return (
          <div key={'share_task_' + k}>
            {item.Share}%
          </div>
        )
      }
      return (
        <li className='clearfix' key={'share_' + key}>
          {share.ReportTask !== null && (<div>
            <div className='strike_through' />
            <strong>{translation('415')}</strong>
            <span>{share.ReportTask.ReportItemGenericValue}</span>
          </div>)}
          <div>
            {share.ApromasTasks.map(renderTask)}
          </div>
        </li>
      )
    }
    // renderTask
    const renderTask = (task, key) => {
      if (task.ReportTask === null) return null
      if (task.ApromasTasks.length === 0) {
        return (
          <li className='clearfix' key={'tasks_' + key}>
            <strong>{task.ReportTask.ReportItemLineText}</strong>
            <div className='clearfix'>
              <span>{task.ReportTask.ReportItemAdditionalText}</span>
              <span>{task.ReportTask.ReportItemWorkUnits} {translation('885')}</span>
            </div>
          </li>
        )
      }
      const renderTask = (item, k) => {
        const renderExtra = (extra, k) => {
          return (
            <div key={'tasks_task_extra_' + k}>
              {extra.Name}
            </div>
          )
        }
        return (
          <li className='clearfix childitem' key={'tasks_task_' + k}>
            <span>{item.TaskName} {item.ExtentType}</span>
            <span />
            {item.TaskExtras.length !== 0 && (
              <div className='extraThousands'>
                {item.TaskExtras.map(renderExtra)}
              </div>
            )}
          </li>
        )
      }
      return (
        <li className='clearfix' key={'tasks_' + key}>
          <strong>{task.ReportTask.ReportItemLineText}</strong>
          <div className='clearfix'>
            <span>{task.ReportTask.ReportItemAdditionalText}</span>
            <div className='strike_through' />
            <span>{task.ReportTask.ReportItemWorkUnits} {translation('885')}</span>
          </div>
          <ul>
            {task.ApromasTasks.map(renderTask)}
          </ul>
        </li>
      )
    }
    // renderAddon
    const renderAddon = (addon, key) => {
      const renderTask = (task, k) => {
        const renderExtra = (val, k) => {
          let valMatText = ''
          if (val.AE !== 0 || val.Material !== 0) {
            let commaSep = ''
            if (val.AE !== 0 && val.Material !== 0) commaSep = ', '
            valMatText += '('
            if (val.AE !== 0) valMatText += val.AE + ' ' + translation('885')
            valMatText += commaSep
            if (val.Material !== 0) valMatText += val.Material + ' ' + translation('13338')
            valMatText += ')'
          }
          return (
            <Line text={`${val.Name} ${valMatText}`} subLine key={k} />
          )
        }
        return (
          <Line text={`${task.TaskName} ${task.ExtentType}`} subLine key={k}>
            {task.TaskExtras.map(renderExtra)}
          </Line>
        )
      }

      return (
        <li className='extent-content' key={key}>
          <div className='partname'>{translation(addon.Part.DictionaryKey)}</div>
          {addon.ApromasTasks.map(renderTask)}
        </li>
      )
    }

    const hasAddons = afterEval.Items.Addons.length > 0 ||
      afterEval.Items.AddonStartTimes.length > 0 ||
      afterEval.Items.Addons.AddonHourPrices > 0 ||
      afterEval.Items.Addons.AddonMaterialsShares > 0 ||
      afterEval.Items.Addons.AddonRefinishTypes > 0

    // Return
    return (
      <Panel title={translation('1037')}>
        <ul>
          {afterEval.Items.RefinishTypes.map(renderRefinishType)}
          {afterEval.Items.StartTimes.map(renderStartTime)}
          {afterEval.Items.HourPrices.map(renderHourPrice)}
          {afterEval.Items.MaterialsShares.map(renderMaterialShare)}
          {afterEval.Items.Tasks.map(renderTask)}
        </ul>

        {hasAddons && [
          <PanelHeader text={translation('2256')} key='header' />,

          <ul key='list'>
            {afterEval.Items.Addons.map(renderAddon)}

            <Divider noLine />

            {afterEval.Items.AddonRefinishTypes.length > 0 && (
              <LabelWrapper labelText={translation('1999')}>
                {afterEval.Items.AddonRefinishTypes.map(renderRefinishType)}
              </LabelWrapper>
            )}

            {afterEval.Items.AddonStartTimes.length > 0 && (
              <LabelWrapper labelText={translation('1195')}>
                {afterEval.Items.AddonStartTimes.map(renderStartTime)}
              </LabelWrapper>
            )}

            {afterEval.Items.AddonHourPrices.length > 0 && (
              <LabelWrapper labelText={translation('419')}>
                {afterEval.Items.AddonHourPrices.map(renderHourPrice)}
              </LabelWrapper>
            )}

            {afterEval.Items.AddonMaterialsShares.length > 0 && (
              <LabelWrapper labelText={translation('415')}>
                {afterEval.Items.AddonMaterialsShares.map(renderMaterialShare)}
              </LabelWrapper>
            )}
          </ul>
        ]}

        {afterEval.Photos.length !== 0 && (
          <LabelWrapper labelText={translation('1011')}>
            <Gallery files={afterEval.Photos} renderImage={renderImage} />
          </LabelWrapper>
        )}

        {afterEval.Comment !== null && [
          (!hasAccess([4], this.props.auth.user.UserType) || (hasAccess([4], this.props.auth.user.UserType) && afterEval.Comment.NoteTypeID === 1)) && (
            <LabelWrapper labelText={translation('149')} key='comment'>
              <div>{afterEval.Comment.Note}</div>
            </LabelWrapper>
          ),
          !hasAccess([4], this.props.auth.user.UserType) && (
            <div key='noteinfo'>
              <LabelWrapper labelText={translation('13429')}>
                {afterEval.Comment.NoteTypeID === 1 ? translation('47') : translation('48')}
              </LabelWrapper>
              <LabelWrapper labelText={translation('1785')}>
                {afterEval.Comment.ApplyToInvoice ? translation('47') : translation('48')}
              </LabelWrapper>
              {afterEval.Comment.ShareType > 0 && (<LabelWrapper labelText={translation('17861')}>
                {getOrderNoteShareString(afterEval.Comment.ShareType)}
              </LabelWrapper>)}
            </div>
          )
        ]}

        <LabelWrapper labelText={translation('263')}>
          <UserInfo user={afterEval.UserInfo} />
        </LabelWrapper>
        <LabelWrapper labelText={translation('176')}>
          {renderFullDate(afterEval.CreatedDate)}
        </LabelWrapper>
      </Panel>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    order: state.orders.order,
    brands: state.common.brands,
    orderTypes: state.common.enums.orderTypes,
    transport: state.common.transport,
    doors: state.common.doors,
    loosePartType: state.common.loosePartType,
    currencyCode: state.common.currencyCode
  }
}

export default connect(mapStateToProps, {
  getDocQuality,
  getDocProcess,
  getDocPhoto,
  getDocDeviations,
  getDocEvaluations,
  getDocOtherDamages,
  getCarOwnerStatus,
  triggerPopupActionBG,
  // openOverlay,
  triggerPopup,
  updateCarOwner,
  sendInvitation
})(Documentation)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/Order/Documentation/index.js